import { toStudyEntityModificationInfo, } from '../study-versions/study-entity-modification-info.js';
import { checkDefined, IllegalArgumentError } from 'faro-common-model';
import { toStudyRevisionAttribute } from './study-revision-attribute.js';
export function toStudyRevision(studyRevision) {
    var _a;
    checkDefined(studyRevision.id, 'StudyRevision', 'id');
    checkDefined(studyRevision.studyId, 'StudyRevision', 'studyId');
    if (!studyRevision.revision || !studyRevision.created || studyRevision.changedData.length == 0) {
        throw new IllegalArgumentError('Invalid StudyRevision. Missing required properties');
    }
    return {
        id: studyRevision.id,
        studyId: studyRevision.studyId,
        revision: studyRevision.revision,
        userId: studyRevision.userId,
        created: typeof studyRevision.created === 'string'
            ? new Date(Date.parse(studyRevision.created))
            : studyRevision.created,
        changedData: (_a = studyRevision.changedData) === null || _a === void 0 ? void 0 : _a.map(d => toStudyEntityModificationInfo(d)),
        attribute: studyRevision.attribute && toStudyRevisionAttribute(studyRevision.attribute),
        hasEvents: studyRevision.hasEvents,
    };
}
//# sourceMappingURL=study-revision.js.map